import React, { useEffect, useState } from 'react';
import { SpinningLoader } from '@nicheinc/campus-ds';
import { RedirectStatusMessage } from './components';
import * as S from './MobileAppRedirect.styles';
import { env } from '@app/env';

function MobileAppRedirect() {
	const [showSpinner, setShowSpinner] = useState(true);
	const [redirectFailed, setRedirectFailed] = useState(false);

	const isOnMobile =
		/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
			navigator.userAgent,
		);
	const isAndroid = /Android/i.test(navigator.userAgent);

	let _mobileAppRedirectUrl;
	if (isAndroid) {
		// Android uses goodkind:// scheme for all environments
		_mobileAppRedirectUrl = 'goodkind://';
	} else {
		// iOS uses environment-specific custom schemes
		if (env.NODE_ENV === 'prod') {
			_mobileAppRedirectUrl = 'app.goodkind://';
		} else {
			_mobileAppRedirectUrl = `niche.engage.${env.NODE_ENV}://`;
		}
	}

	const appStoreUrl = isAndroid
		? 'https://play.google.com/store/apps/details?id=app.goodkind'
		: 'https://apps.apple.com/us/app/id1586742206';

	// Detect when user leaves the page (app likely opened)
	const handleVisibilityChange = () => {
		if (document.visibilityState === 'hidden') {
			// User left the page - app likely opened successfully
			setShowSpinner(false);
		}
	};

	useEffect(() => {
		document.addEventListener('visibilitychange', handleVisibilityChange);

		// Try to open the app with deep link
		window.location.href = _mobileAppRedirectUrl;

		// After 5 seconds, assume redirect failed and show error message
		const redirectTimer = setTimeout(() => {
			setShowSpinner(false);
			setRedirectFailed(true);
		}, 5000);

		return () => {
			clearTimeout(redirectTimer);
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, []);

	return (
		<S.MobileAppRedirectContainer>
			<RedirectStatusMessage
				currentUserIsOnMobile={isOnMobile}
				redirectFailed={redirectFailed}
			/>

			{isOnMobile && showSpinner && <SpinningLoader loading />}

			{isOnMobile && (
				<S.DownloadButton
					href={appStoreUrl}
					target="_blank"
					rel="noopener noreferrer"
				>
					Download App
				</S.DownloadButton>
			)}
		</S.MobileAppRedirectContainer>
	);
}

export default MobileAppRedirect;
